import React, { useEffect } from "react";
import DOMPurify from "isomorphic-dompurify";
import { IInnerHTMLTextProps } from "./InnerHTMLText.props";
import cn from "classnames";

import styles from "./InnerHTMLText.module.scss";

const InnerHTMLTextLazy: React.FunctionComponent<IInnerHTMLTextProps> = ({
  tag = "div",
  text,
  className,
  style,
  onLoad,
  ...props
}) => {
  useEffect(() => {
    if (onLoad) {
      onLoad();
    }
  }, []);

  return React.createElement(tag, {
    className: cn(styles["text"], className),
    style: style,
    dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(text, { ADD_ATTR: ["target", "allow", "title"], ADD_TAGS: ["iframe"] }) },
    ...props,
  });
};

export default InnerHTMLTextLazy;